import type { AxiosInstance } from 'axios'
import { useGameContest } from '@/store'

import type { ClientApi } from '../../api'

export default ($axios: AxiosInstance): ClientApi['contestGames'] => ({
  read(id: string, storeSlug: string) {
    const store = useGameContest()
    return $axios.get(`/public/contest-games/${id}/stores/${storeSlug}?locale=${store.locale}`)
  },
  readByPublicId(id: string) {
    const store = useGameContest()
    return $axios.get(`/public/contest-games/${id}/stores?locale=${store.locale}`)
  },
})
